export default __webpack_public_path__ + "c723d152c9a4385a65d6526cde40e1d4.woff2";